export interface OrganizationsListColumn {
  key: string;
  label: string;
  // Percentage of the row's width, same convention as the leads table
  // (useLeadsTableHeader.tsx) - columns scale proportionally with the row
  // instead of a single column absorbing all leftover space.
  size: string;
  // Floor in px so columns don't get crushed on narrow screens, also matching
  // the leads table convention.
  minWidth?: string;
  align?: "left" | "center" | "right";
  sortable?: boolean;
}

export const ORGANIZATIONS_LIST_COLUMNS: OrganizationsListColumn[] = [
  { key: "name", label: "Organization", size: "22%", minWidth: "200px", sortable: true },
  { key: "location", label: "Location", size: "20%", minWidth: "160px", sortable: true },
  {
    key: "isActive",
    label: "Access",
    size: "12%",
    minWidth: "100px",
    align: "center",
    sortable: true,
  },
  { key: "createdAt", label: "Date Created", size: "14%", minWidth: "130px", sortable: true },
  {
    key: "updatedAt",
    label: "Last Updated",
    size: "14%",
    minWidth: "130px",
    sortable: true,
  },
  { key: "goToOrg", label: "Go to Org", size: "10%", minWidth: "90px", align: "center" },
  { key: "actions", label: "", size: "8%", minWidth: "70px", align: "right" },
];
